import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { NumberFormatValues } from 'react-number-format';
import { CSSProperties } from "react";

export interface DefaultControlProps {
    id?: string;
    name: string;
    onChange?: any;
    onBlur?: any;
    defaultValue?: string;
    className?: string;
    toolTip?: string;
    disabled?: boolean;
    style?: CSSProperties;
    tabIndex?: number;
}

export interface PhoneNumberProps extends DefaultControlProps {
    countryCode?: string;
    readOnly?: boolean;
}

const PhoneNumberControl = (props: PhoneNumberProps) => {

    const [phoneNumber, setPhoneNumner] = useState(props.defaultValue);
    const phoneCountry = "US";

    useEffect(
        () => (
            setPhoneNumner(props.defaultValue)
        ),
        [props.defaultValue]
    );

    const onChangeInternal = (e: NumberFormatValues) => {
        setPhoneNumner(e.formattedValue);
        if (props.onChange !== undefined) {
            props.onChange(e);
        }
    }

    return (
        <NumberFormat customInput={Form.Control} readOnly={props.readOnly} className={props.className} format={phoneCountry.toUpperCase() === "US" ? "###-###-####" : "###############"}
            mask="_" id={props.id} name={props.name} value={phoneNumber} onValueChange={onChangeInternal} title={props.toolTip} disabled={props.disabled} onBlur={(e) => { (props.onBlur !== undefined) && props.onBlur(e) }} />
    )
};

export { PhoneNumberControl };
